import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'gstrTwoBDetailsNearMatchData',
  components: {},
  watch: {
    currentPage: function() {
      this.getGstrDetails();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getGstrDetails();
    }
  },
  props: ['rowDetails', 'leId'],
  data() {
    return {
      unsubscribe: null,
      loader: false,
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      currentPage: 1,
      totalRows: null,
      perPage: commonHelper.perPageData,
      pageOptions: commonHelper.getPageOption(),
      vsetCode: null,
      parent_value_set_id: null,
      invoice_id: null,
      dtlId: null,
      reco_flag_2b: null,
      status: null,
      le_id: true,
      nearMatchdata: [],
      nearMatchFields: [
        {
          key: 'selectBox',
          label: 'Select',
          stickyColumn: true,
          variant: 'primary'
        },
        {
          key: 'vendor_name_pr',
          label: 'Vendor Name',
          class: 'text-center'
        },
        {
          key: 'vendor_num',
          label: 'Vendor Number',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'fp_gstn_pr',
          label: 'GSTR 2B',
          class: 'text-center'
        },
        {
          key: 'tpgstn_2b',
          label: 'GSTR 2B',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'tpgstn',
          label: 'ERP',
          class: 'text-center'
        },
        {
          key: 'invoice_no_2b',
          label: 'GSTR 2B',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'invoice_no_pr',
          label: 'ERP',
          class: 'text-center'
        },
        {
          key: 'date_2b',
          label: 'GSTR 2B',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'date_pr',
          label: 'ERP',
          class: 'text-center'
        },
        {
          key: 'taxable_value_2b',
          label: 'GSTR 2B',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'taxable_value_pr',
          label: 'ERP',
          class: 'text-center'
        },
        {
          key: 'total_tax_2b',
          label: 'GSTR 2B',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'total_tax_pr',
          label: 'ERP',
          class: 'text-center'
        },
        {
          key: 'igst_2b',
          label: 'GSTR 2B',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'igst_pr',
          label: 'ERP',
          class: 'text-center'
        },
        {
          key: 'cgst_2b',
          label: 'GSTR 2B',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'cgst_pr',
          label: 'ERP',
          class: 'text-center'
        },
        {
          key: 'sgst_2b',
          label: 'GSTR 2B',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'sgst_pr',
          label: 'ERP',
          class: 'text-center'
        },
        {
          key: 'rate',
          label: 'GSTR 2B',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'match_score',
          label: 'Matching Percentage',
          class: 'text-center'
        },
        {
          key: 'invoice_id',
          label: 'Invoice ID',
          variant: 'success',
          class: 'text-center'
        },
        {
          key: 'dtl_id',
          label: 'Detail ID',
          class: 'text-center'
        },
        {
          key: 'request_id',
          label: 'Request ID',
          variant: 'success',
          class: 'text-center'
        }
      ],
      downloadPayload: null
    };
  },
  mounted() {
    this.getGstrDetails();
  },
  methods: {
    downloadExcelData() {
      this.loader = true;
      const downloadpayload = {...this.downloadPayload};
      downloadpayload._limit = this.totalRows;
      this.downloadExcel.downloadData(
        downloadpayload,
        'complainceDashboard/getComplainceGstr2bNearMatchDetails',
        'gstr-twoB-near-match',
      () => (this.loader = false)
      );
    },
    formattedNumber(num) {
      return commonHelper.formatCurrency(num);
    },
    selectedRecord(item) {
     this.le_id = this.leId;
     this.invoice_id = item.invoice_id; 
     this.dtlId = item.dtl_id;
    },
    updateNearMatch() {
      const payload = {
        le_id: this.le_id,
        invoice_id: this.invoice_id,
        dtl_id: this.dtlId,
      };
      this.loader = true;
      this.$store
        .dispatch(
          'complainceDashboard/updateGst2bNearMatchDetails',
          payload
        )
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.responseMsg = response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getGstrDetails() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        le_id: this.leId,
        dtl_id: this.rowDetails.dtl_id
      };
      this.downloadPayload = payload;
      this.loader = true;
      this.$store
        .dispatch(
          'complainceDashboard/getComplainceGstr2bNearMatchDetails',
          payload
        )
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.nearMatchdata = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
  }
};
